import ReportSectionContent from "../../../components/UI/ReportSectionContent";
import { examCardEnums } from "../../../enums";
import EyeReport from "./EyeReport";

const VisualAcuityReport = () => {
  return (
    <ReportSectionContent
      sectionName={examCardEnums.VISUAL_ACUITY.sectionName}
      EyeReport={<EyeReport />}
    />
  );
};

export default VisualAcuityReport;
